<template>
  <div class="wrap-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "WrapContainer"
};
</script>

<style scoped>
div.wrap-container {
  text-align: left;
  box-sizing: border-box;
  vertical-align: top;
}
</style>
